import FeatureMiddleware from '@/middleware/FeatureMiddleware.js';
import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';

export default [
    {
        path: '/meetings',
        component: () => import('@/pages/meetings/MeetingsIndex.vue'),
        props: true,
        children: [
            {
                path: '',
                name: 'meetings-index',
                component: () => import('@/components/meetings/MeetingsView.vue'),
                meta: {
                    title: 'Meetings',
                    middleware: [GateKeeperMiddleware],
                    ability: { action: 'view all', subject: 'meetings' },
                },
                props: true,
                beforeEnter: FeatureMiddleware('MEETINGS'),
            },
        ],
    },
];
